import React from 'react'
import ExperienceItem from '../components/ExperienceItem'

function Volunteering() {
  return (
    <div className='w-full lg:w-[60%] min-h-screen py-12 lg:py-20 px-6 lg:px-20 bg-white relative lg:left-[300px]'>
        <p className='w-full text-black text-sm text-left py-2'>
            Apart from my studies and software engineer career, I do participate in many connects and sessions to deliver my knowledge and gain networks.
        </p>
        <div className='w-full py-4 flex flex-col items-center'>
            <ExperienceItem 
              title='Technology Evangelist'
              company='Tata Consultancy Services'
              started='Jan 2022'
              ended='Mar 2024'
              isCompleted={true}
              tech={['Technical Webinars','Learn in a day']}
              responsibilities={['Conducted "Learn in a day" session about modern technologies like Amazon Web Services and NodeJS for undergraduate students to level up their skills.',
              'Made hands-on session to students and professors to clear their doubts and deploy web applications.']}
              image="./tcs-aip.jpeg"
            />
            <ExperienceItem
              title='Mozilla Campus Club'
              company='Sri Manakula Vinayagar Engineering College'
              started='Jan 2020'
              isCompleted={true}
              tags={['Campus Lead']}
              ended='Sep 2020'
              tech={['Awareness Programs','Online Webinars','COVID Campaigns']}
              responsibilities={['Organised a team and conducted daily webinars/courses in Python, C and Photoshop for 12th grade students via web application and evaluated them with quiz using Google Forms, provided e-certificates generated by python automation during COVID-19 period.',
              'Helped undergrad students to prepare for contest by providing them information about right materials and open source softwares.',
              'Conducted awareness hackathons among students, for exploring technologies like Javascript, Python, Android and IOS development, Cloud Services like Firebase (Google Cloud).']}
            />
            <ExperienceItem
              title='Google Developer Students Club'
              company='Sri Manakula Vinayar Engineering College'
              started='Oct 2019'
              isCompleted={true}
              ended='Sep 2020'
              tags={['Core Team Member']}
              tech={['Online Webinars','Technical Programs']}
              responsibilities={['Organised and hosted Flutter webinars for undergrad students and provided them swags and other materials needed to prepare some projects.',
              'Organised and been part of a team to conduct online live webinars for Web Development technologies (HTML5, CSS3, JavaScript) during COVID-19 period.',
              'Made surveys among students on technologies they were interested and organised a team to conduct a learning series to undergrads which includes programming languages like C, C++, Java and Python.']}
            />
        </div>
        <p onClick={() => {
            document.body.scrollTop = 0;
            document.documentElement.scrollTop = 0;
        }} className='w-full text-right py-2 text-sm underline text-black cursor-pointer'>Back to top</p>
    </div>
  )
}

export default Volunteering